import axios from "axios";
import {baseUrl_back} from "./BaseUrl";

export default class BackServer {

    // byListID
    static async GetFavorites(ProductList) {
        const response = await axios.post(`${baseUrl_back}/product/byDictID`, {
            productlist: ProductList
        })
        return response.data
    }

    static async GetDistinctFilters(categoryx,filtersx) {
        const response = await axios.post(`${baseUrl_back}/product/byFilters`,{
            category:categoryx,
            filters: filtersx,

        })
        return response.data
    }

    static async GetCart(ProductList) {
        const response = await axios.post(`${baseUrl_back}/product/byDictID`, {
            productlist: ProductList
        })
      //  console.log("Ssssssssssssssssssssssss")
        return response.data
    }

    static async CreateNewOrder(OrderData) {
        const response = await axios.post(`${baseUrl_back}/order`, OrderData)
         // console.log(response.data)
        return response.data
    }


    static async AddEditProduct(ProductData) {
        const response = await axios.post(`${baseUrl_back}/product/addSite`, ProductData)
        return response.data
    }

    static async GetAdress(query) {
        var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
        var token = "a771efc98492525a50504e8c8fbceda10f539282";
        var options = {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({query: query})
        }
        // return await axios.post(url,{
        //     body: JSON.stringify({query: query})
        // },{
        //     headers: {
        //         "Content-Type": "application/json",
        //         "Accept": "application/json",
        //         "Authorization": "Token " + token
        //     },
        //     mode: "cors"
        // }).then(value => {
        //     console.log(value.text())
        // })
       return  await fetch(url, options).then((response) => {
              //  console.log(response);
                response.text().then((data) => {
                     // console.log(data);
                    return data;
                }).catch((err) => {
                    console.log(err);
                })
            });
    }

    static async GetCategories() {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/category`)
        return response.data
    }

    static async GetProductByCatId(categoryId) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/product/byCategoryID?categoryId=`+categoryId)
        return response.data
    }

    static async getStockFromMyBD(article) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/goBananasBot/getStockFromMyBD?article=`+ article)
        return response.data
    }

    static async getStockFromMyBDNEW(article,nme) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/goBananasBot/getStockFromMyBDNEW?article=`+ article+`&nme=`+ nme)
        return response.data
    }

    static async getAllArticlesW(article,nme,sort) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/goBananasBot/getArticlesByFilter?article=`+ article+`&nme=`+ nme+`&sort=${sort}`)
        return response.data
    }

    static async getAllColors(article,nme,sort) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/goBananasBot/getAllColors`)
        return response.data
    }

    static async addstock(article,stock,tpe) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/goBananasBot/addstock?article=`+ article+`&stock=`+stock+`&type=`+ tpe)
        return response.data
    }

    static async addcolor(article,color) {
        // const response = await axios.get(`${baseUrl_back}categories`)
        const response = await axios.get(`${baseUrl_back}/goBananasBot/addcolor?article=`+ article+`&color=`+color)
        return response.data
    }

    static async GetDistinct() {
        const response = await axios.get(`${baseUrl_back}/utils/getDistinct`)
        return response.data
    }

    static async GetDistinctByCatID(CatID) {
        const response = await axios.get(`${baseUrl_back}/utils/getDistinctByCatID?category_id=`+CatID)
        return response.data
    }




    static async GetProductById(productId) {
        const response = await axios.get(`${baseUrl_back}/product/byProductID?id=`+productId)
        return response.data
    }


}

